module.exports = __webpack_public_path__ + "img/onboardingmyway.bc76a7dd.png";